import { useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

const HEADER_HEIGHT = 64;

export function useContactCenterDimensions() {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const [viewport, setViewport] = useState(() => ({
    width: typeof window !== "undefined" ? window.innerWidth : 390,
    height: typeof window !== "undefined" ? window.innerHeight : 800,
  }));

  useEffect(() => {
    const onResize = () => {
      setViewport({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return useMemo(() => {
    const width = isLgUp
      ? 450
      : isMdUp
        ? 430
        : isSmUp
          ? 360
          : Math.min(viewport.width - 32, 390);

    const panelHeight = isMdUp
      ? 760
      : isSmUp
        ? 600
        : Math.max(400, Math.min(viewport.height * 0.9 - 90, viewport.height * 0.9));

    return {
      width,
      panelHeight,
      headerHeight: HEADER_HEIGHT,
      bodyHeight: panelHeight - HEADER_HEIGHT,
    };
  }, [isSmUp, isMdUp, isLgUp, viewport.width, viewport.height]);
}
